import { NgModule, ApplicationRef } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { AgmCoreModule } from '@agm/core';
import { ChartsModule } from 'ng2-charts';

import { CoreModule } from './core/core.module';

import { AppComponent } from './app.component';
import { AmberMapComponent } from './amber-map/amber-map.component';
import { AmberClassifierComponent } from './amber-classifier/amber-classifier.component';
import { AmberSpotterComponent } from './amber-spotter/amber-spotter.component';
import { AmberBarrierLocationComponent } from './amber-barrier-location/amber-barrier-location.component';
import { AmberClassificationsComponent } from './amber-classifications/amber-classifications.component';
import { AmberDownloadFormComponent } from './amber-download-form/amber-download-form.component';

import { BarrierNamePipe, BarrierHeightPipe, BarrierPhotoPipe } from './shared';
import { DatePipe } from '@angular/common';
// import { routing } from './app.routing';

import { removeNgStyles, createNewHosts } from '@angularclass/hmr';

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpModule,
    FormsModule,
    ChartsModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyAY-_7kCfqBz2cOCNdZg52nZenBDqpWRB8',
      apiVersion: '3.30'
    }),
    CoreModule
    // routing
  ],
  declarations: [
    AppComponent,
    AmberMapComponent,
    AmberClassifierComponent,
    AmberClassificationsComponent,
    AmberSpotterComponent,
    AmberBarrierLocationComponent,
    AmberDownloadFormComponent,
    BarrierNamePipe,
    BarrierHeightPipe,
    BarrierPhotoPipe
  ],
  providers: [
    BarrierNamePipe,
    DatePipe
  ],
  entryComponents: [
    AmberMapComponent,
    AmberClassifierComponent,
    AmberSpotterComponent,
    AmberBarrierLocationComponent,
    AmberClassificationsComponent,
    AmberDownloadFormComponent
  ]
  // bootstrap: [AmberMapComponent, AmberClassifierComponent]
})
export class AppModule {
  constructor(public appRef: ApplicationRef) { }
  hmrOnInit(store) {
    console.log('HMR store', store);
  }
  hmrOnDestroy(store) {
    let cmpLocation = this.appRef.components.map(cmp => cmp.location.nativeElement);
    // recreate elements
    store.disposeOldHosts = createNewHosts(cmpLocation);
    // remove styles
    removeNgStyles();
  }
  hmrAfterDestroy(store) {
    // display new elements
    store.disposeOldHosts();
    delete store.disposeOldHosts;
  }
  ngDoBootstrap() {
    if (document.querySelector('amber-classifier')) {
      this.appRef.bootstrap(AmberClassifierComponent);
    }
    if (document.querySelector('amber-map')) {
      this.appRef.bootstrap(AmberMapComponent);
    }
    if (document.querySelector('amber-spotter')) {
      this.appRef.bootstrap(AmberSpotterComponent);
    }
    if (document.querySelector('amber-barrier-location')) {
      this.appRef.bootstrap(AmberBarrierLocationComponent);
    }
    if (document.querySelector('amber-classifications')) {
      this.appRef.bootstrap(AmberClassificationsComponent);
    }
    if (document.querySelector('amber-download-form')) {
      this.appRef.bootstrap(AmberDownloadFormComponent);
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/app.module.ts